<template>
  <div class="breadcrumb-route">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item to="/">首页</el-breadcrumb-item>
      <el-breadcrumb-item v-for="bread in mapPaths" :key="bread.path">
        <a :href="bread.path ? bread.path : 'javascript:void(0)'">{{
          bread.title
        }}</a>
      </el-breadcrumb-item>
    </el-breadcrumb>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import {generateQueryPath} from '@/utils'
export default {
  data() {
    return {
      mapPaths: [],
      stepPath: "",
    };
  },
  computed: {
    ...mapGetters(["pagesRoute"]),
    paths() {
      return this.$route.path
        .split("/")
        .filter((i) => i)
        .map((i) => "/" + i);
    },
  },

  created() {
    let page = null;
    this.paths.forEach((item, index, arr) => {
      this.stepPath += item;
      page = this.pagesRoute.find((page) => page.path === this.stepPath);
      this.mapPaths.push({
        path: index === arr.length - 1 ? "" : this.stepPath + '?' + generateQueryPath(this.$route.query),
        title: page ? page.meta.title : "",
      });
    });
    console.log("mapPaths", this.mapPaths,);
  },
};
</script>

<style scoped lang="scss">
.breadcrumb-route {
  display: flex;
  align-items: center;
  height: 52px;
}
</style>